function authHeaders(token) {
  return { Authorization: `Bearer ${token}` };
}

export function shareBackend(apiUrl) {
  return {
    async projects(token) {
      const res = await fetch(`${apiUrl}/stories`, { headers: authHeaders(token) });
      if (!res.ok) throw new Error(res.status);
      return res.json();
    },

    async load(token, id) {
      const res = await fetch(`${apiUrl}/stories/${id}`, { headers: authHeaders(token) });
      if (!res.ok) throw new Error(res.status);
      return res.json();
    },

    async save(token, id, data) {
      const res = await fetch(`${apiUrl}/stories/${id}`, {
        method: 'POST',
        headers: { ...authHeaders(token), 'Content-type': 'application/json; charset=UTF-8' },
        body: JSON.stringify(data),
      });
      if (!res.ok) throw new Error(res.status);
      return res.json();
    },

    async addproject(token, projectName, projectDescription) {
      const res = await fetch(`${apiUrl}/stories`, {
        method: 'POST',
        headers: { ...authHeaders(token), 'Content-type': 'application/json; charset=UTF-8' },
        body: JSON.stringify({ name: projectName, description: projectDescription }),
      });
      if (!res.ok) throw new Error(res.status);
      return res.json();
    },

    async delete(token, id) {
      const res = await fetch(`${apiUrl}/stories/${id}`, {
        method: 'DELETE',
        headers: authHeaders(token),
      });
      if (!res.ok) throw new Error(res.status);
      return res.json();
    },

    async updateMeta(token, id, meta) {
      const res = await fetch(`${apiUrl}/stories/${id}/meta`, {
        method: 'POST',
        headers: { ...authHeaders(token), 'Content-type': 'application/json; charset=UTF-8' },
        body: JSON.stringify(meta),
      });
      if (!res.ok) throw new Error(res.status);
      return res.json();
    },

    async saveCss(token, id, css) {
      const res = await fetch(`${apiUrl}/stories/${id}/css`, {
        method: 'POST',
        headers: { ...authHeaders(token), 'Content-type': 'text/plain; charset=UTF-8' },
        body: css,
      });
      if (!res.ok) throw new Error(res.status);
      return res.json();
    },

    async saveConfig(token, id, config) {
      const res = await fetch(`${apiUrl}/stories/${id}/config`, {
        method: 'POST',
        headers: { ...authHeaders(token), 'Content-type': 'application/json; charset=UTF-8' },
        body: JSON.stringify(config),
      });
      if (!res.ok) throw new Error(res.status);
      return res.json();
    },

    async publish(token, id) {
      const res = await fetch(`${apiUrl}/stories/${id}/publish`, {
        method: 'POST',
        headers: authHeaders(token),
      });
      if (!res.ok) throw new Error(res.status);
      return res.json();
    },

    async unpublish(token, id) {
      const res = await fetch(`${apiUrl}/stories/${id}/unpublish`, {
        method: 'POST',
        headers: authHeaders(token),
      });
      if (!res.ok) throw new Error(res.status);
      return res.json();
    },

    async readMeta(token, id) {
      const res = await fetch(`${apiUrl}/stories/${id}/meta`, { headers: authHeaders(token) });
      if (!res.ok) throw new Error(res.status);
      return res.json();
    },

    async readCss(token, id) {
      const res = await fetch(`${apiUrl}/stories/${id}/css`, { headers: authHeaders(token) });
      if (!res.ok) throw new Error(res.status);
      return res.text();
    },

    async readConfig(token, id) {
      const res = await fetch(`${apiUrl}/stories/${id}/config`, { headers: authHeaders(token) });
      if (!res.ok) throw new Error(res.status);
      return res.text();
    },

    async listRuntimes() {
      const res = await fetch(`${apiUrl}/runtimes/list`);
      if (!res.ok) throw new Error(res.status);
      return res.json();
    },

    async listTags() {
      const res = await fetch(`${apiUrl}/browse/tags`);
      if (!res.ok) throw new Error(res.status);
      return res.json();
    },

    // Both image uploads return a parsed JSON body even on failure (an
    // {error} message from validation) rather than throwing, so the caller
    // can show *why* the upload was rejected instead of just that it failed.
    async uploadBanner(token, id, file) {
      const formData = new FormData();
      formData.append('file', file);
      const res = await fetch(`${apiUrl}/stories/${id}/banner`, {
        method: 'POST',
        headers: authHeaders(token),
        body: formData,
      });
      return res.json();
    },

    async uploadThumbnail(token, id, file) {
      const formData = new FormData();
      formData.append('file', file);
      const res = await fetch(`${apiUrl}/stories/${id}/thumbnail`, {
        method: 'POST',
        headers: authHeaders(token),
        body: formData,
      });
      return res.json();
    },
  };
}
